var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3067 58.8163C55.1757 58.8163 59.1229 54.8691 59.1229 50.0001C59.1229 45.131 55.1757 41.1838 50.3067 41.1838C45.4376 41.1838 41.4904 45.131 41.4904 50.0001C41.4904 54.8691 45.4376 58.8163 50.3067 58.8163Z",
    fill: "#61DAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3066 68.0626C76.4333 68.0626 97.6132 59.9757 97.6132 50C97.6132 40.0244 76.4333 31.9375 50.3066 31.9375C24.1799 31.9375 3 40.0244 3 50C3 59.9757 24.1799 68.0626 50.3066 68.0626Z",
    stroke: "#61DAFB",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.664 59.0313C47.7273 81.6577 65.3207 95.9566 73.9599 90.9687C82.5991 85.9809 79.0125 63.5951 65.9492 40.9687C52.8858 18.3423 35.2924 4.04343 26.6533 9.03126C18.0141 14.0191 21.6006 36.4049 34.664 59.0313Z",
    stroke: "#61DAFB",
    strokeWidth: 5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.664 40.9687C21.6006 63.5951 18.0141 85.9809 26.6533 90.9687C35.2925 95.9565 52.8858 81.6576 65.9492 59.0312C79.0126 36.4048 82.5991 14.0191 73.9599 9.03124C65.3207 4.04341 47.7273 18.3423 34.664 40.9687Z",
    stroke: "#61DAFB",
    strokeWidth: 5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/react.83f9453a0a5e7d0137f7ffc7fc445885.svg";
export { ForwardRef as ReactComponent };